import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["MyCourseCardAction"] */ "/app/src/app/[domain]/[locale]/my-classes/[format]/[id]/components/my-course-card-action.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/filter-tab/filter-tab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/progress.tsx");
